import { useEffect, useState } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ActiveBrandContext, SetActiveBrandContext, UserBrandsContext } from '@trinity/chat-components/containers/UserBrands/UserBrandsContext.js';
import { useAppReadyState } from '../AppReadyState';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';


type Props = ChildrenProps;

export const UserBrandsContainer = (props: Props) => {
  const app = useAppReadyState();
  const [activeBrandIdentifier, setActiveBrandIdentifier] = useState<string | null>(null);

  const apiClient = useChatApiClient();

  const q = useQuery({
    queryKey: ['get:user-brands'],
    queryFn: async () => {
      const res = await apiClient.users.getUserBrands().then(r => r.brands);

      if (!res.length) {
        throw new Error('No brands found for the user');
      }

      return res;
    },
    enabled: app.authenticated,
    initialData: [],
    placeholderData: keepPreviousData,
  });

  useEffect(() => {
    if (!activeBrandIdentifier && q.data.length) {
      // Set the first brand as the default user brand
      setActiveBrandIdentifier(q.data[0].identifier);
    }
  }, [activeBrandIdentifier, q.data]);

  return (
    <ActiveBrandContext.Provider value={activeBrandIdentifier}>
      <SetActiveBrandContext.Provider value={setActiveBrandIdentifier}>
        <UserBrandsContext.Provider value={q.data}>
          {props.children}
        </UserBrandsContext.Provider>
      </SetActiveBrandContext.Provider>
    </ActiveBrandContext.Provider>
  );
};